import Icon from './components/Icon';
import Svg from './svg/session-planned.svg';

export default (props) => <Icon component={Svg} data-name="PlannedIcon" {...props} />;
